import * as React from "react";

const SheetLayerContext = React.createContext(false);

export function SheetLayerProvider({ children }: { children: React.ReactNode }) {
  return (
    <SheetLayerContext.Provider value={true}>
      {children}
    </SheetLayerContext.Provider>
  );
}

/**
 * Returns `true` when the calling component is rendered inside a MultiSheetPanel.
 * Portaled UI primitives (Dialog, Popover, Select, DropdownMenu, Tooltip) use
 * this to raise their z-index above the sheet layer.
 */
// eslint-disable-next-line react-refresh/only-export-components
export function useInsideSheet() {
  return React.useContext(SheetLayerContext);
}
